import { Component, ComponentRef, ViewChild, inject } from '@angular/core';
import { ClaimShipmentLine } from '../../../generic/classes/claim.shipment.line';
import { DynamicModalDirective } from '../../../generic/component/modal/dynamic.modal.directive';
import { ModalWrapperComponent } from '../../../generic/component/modal/modal.wrapper.component';
import { Logger } from '../../../generic/logging/default-log.service';
import { ApplicationService } from '../../../generic/service/application.service';
import { ProductService } from '../../../generic/service/product.service';
import { ClaimService } from '../../../service/claim.service';
import { NewClaimModalComponent } from './new.claim.modal.component';
import { NumberFormatPipe } from '../../../generic/pipes/number.format.pipe';
import { CustomDatePipe } from '../../../generic/pipes/custom.date.pipe';
import { RenderProductImageComponent } from '../../../generic/component/products/render.product.image';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'new-claim-overview',
    templateUrl: 'new.claim.overview.component.html',
    styleUrls: ['./claim.component.scss'],
    standalone: true,
    imports: [
        RouterLink,
        RenderProductImageComponent,
        DynamicModalDirective,
        CustomDatePipe,
        NumberFormatPipe,
    ],
})
export class NewClaimOverviewComponent {
    applicationService = inject(ApplicationService);
    private productService = inject(ProductService);
    private claimService = inject(ClaimService);
    private logger = inject(Logger);

    claimableShipmentLines: ClaimShipmentLine[] = [];
    noClaimableShipmentLines: boolean = false;

    _componentRef: ComponentRef<any>;
    @ViewChild(DynamicModalDirective) modalWrapper: DynamicModalDirective;

    constructor() {
        this.claimService.getClaimableShipmentLines().subscribe(
            shipmentLines => this.setClaimableShipmentLines(shipmentLines),
            error =>
                this.logger.warn(
                    'Failed to get claimable shipment lines.',
                    error,
                ),
        );
    }

    startNewClaim(shipmentLine: ClaimShipmentLine): void {
        this.showClaimModal({
            articleDescription: shipmentLine.description,
            orderId: shipmentLine.sourceNo,
            sourceLineNo: shipmentLine.sourceNo2,
            boxQuantity: shipmentLine.boxQuantity,
            quantityPerBox: shipmentLine.quantityPerBox,
            amountOrdered:
                shipmentLine.boxQuantity * shipmentLine.quantityPerBox,
        });
    }

    getImageId(image: string): any {
        return this.productService.getImage(image);
    }

    private showClaimModal(data: any): void {
        const claimModalWrapper = new ModalWrapperComponent(
            NewClaimModalComponent,
            data,
        );
        const viewContainerRef = this.modalWrapper.viewContainerRef;
        viewContainerRef.clear();

        this._componentRef = viewContainerRef.createComponent(
            claimModalWrapper.component,
        );
        this._componentRef.instance._componentRef = this._componentRef;
        (<ModalWrapperComponent>this._componentRef.instance).data = data;

        this._componentRef.instance.reloadShipmentLines.subscribe(reload => {
            if (reload) {
                this.claimService.getClaimableShipmentLines().subscribe(
                    shipmentLines =>
                        this.setClaimableShipmentLines(shipmentLines),
                    error =>
                        this.logger.warn(
                            'Failed to get claimable shipment lines.',
                            error,
                        ),
                );
            }
        });

        document.querySelector('html')?.classList.add('scroll-lock');
    }

    private setClaimableShipmentLines(
        shipmentLines: ClaimShipmentLine[],
    ): void {
        this.claimableShipmentLines = shipmentLines;
        this.noClaimableShipmentLines = shipmentLines.length === 0;
    }
}
